export default {"src":"/_next/static/media/maths_selected.851417d4.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};